import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Form, Row, Button, Spinner } from 'react-bootstrap';
import Moment from "moment";
import { toast } from 'react-toastify';
import { cashCollectionReportDataAction, cashCollectionReportPdfAPI } from 'actions/CashCollectionReport/cashCollectionReportAction';
import loader from '../../assets/img/loader.svg'

export const CashCollectionReportDetails = () => {
	const dispatch = useDispatch();
	const [isLoading, setIsLoading] = useState(false);
	const [formHasError, setFormError] = useState(false);
	let token = localStorage.getItem('Token') || sessionStorage.getItem('Token');
	const headers = {
		Authorization: `Bearer ${JSON.parse(token).value}`
	};
	const cashCollectionReportReducer = useSelector((state) => state.rootReducer.cashCollectionReportReducer)
	var cashCollectionReportData = cashCollectionReportReducer.cashCollectionReportData;
		useEffect(() => {
			  setTimeout(() => {
				setIsLoading(false);
			  }, 1000);
	}, [isLoading])

	const GenerateCashCollectionReport = async () => {
		if (cashCollectionReportValidation()) {
			let requestData = {
				EncryptedAdvocateCode: localStorage.getItem("EncryptedAdvocateCode"),
				FromDate: cashCollectionReportData.fromDate ? Moment(cashCollectionReportData.fromDate).format("YYYY-MM-DD") : Moment().format("YYYY-MM-DD"),
				ToDate: cashCollectionReportData.toDate ? Moment(cashCollectionReportData.toDate).format("YYYY-MM-DD") : Moment().format("YYYY-MM-DD"),
				ReportType: cashCollectionReportData.reportType ? cashCollectionReportData.reportType : "PaymentWise"
			}
			setIsLoading(true)
			await dispatch(
				cashCollectionReportPdfAPI(
					requestData,
					(res) => {
						setIsLoading(false)
						console.log(res);
					},
					(err) => {
									setIsLoading(false)
						toast.error("No records found!", {
							theme: 'colored',
							autoClose: 10000
						});
						console.error("Error occurred while generating PDF:", err?.message || err);
					},
					headers
				)
			);
		}
	}

	const handleFieldChange = (e) => {
		dispatch(
			cashCollectionReportDataAction({
				...cashCollectionReportData,
				[e.target.name]: e.target.value,
			})
		);
	};

	const cashCollectionReportValidation = () => {
		let isValid = true;
		if (cashCollectionReportData.fromDate > cashCollectionReportData.toDate) {
			toast.error("From Date cannot be greater than To Date", {
				theme: 'colored'
			});
			isValid = false;
			setFormError(true);
		}
		return isValid;
	};

	return (
		<>
			{/* {isLoading ? (
				<Spinner
		  className="loader-color popup-loader position-fixed top-50 start-50 translate-middle z-index-5"
          // className="position-absolute start-50 loader-color"
					animation="border"
				/>
			) : null} */}
			      {isLoading ? (
  <img
    src={loader}
    alt="Loading..."
    className="loader-gif position-fixed top-50 start-50 translate-middle z-index-5"
  />
) : null}

			{/* <Form className="details-form cash-Collection-Report">

				<Row className='justify-content-left ms-2 casSchedule-button'>
					<Form.Label column className='col-auto'>
						From Date
					</Form.Label>
					<Col className='col-auto'>
						<Form.Control type='date' id="dtFromDate" name="fromDate" onChange={handleFieldChange}
							value={cashCollectionReportData.fromDate ? Moment(cashCollectionReportData.fromDate).format('YYYY-MM-DD') : Moment().format('YYYY-MM-DD')}
						/>
					</Col>
					<Form.Label column className='col-auto'>
						To Date
					</Form.Label>
					<Col className='col-auto'>
						<Form.Control type='date' id="dtToDate" name="toDate" onChange={handleFieldChange}
							value={cashCollectionReportData.toDate ? Moment(cashCollectionReportData.toDate).format('YYYY-MM-DD') : Moment().format('YYYY-MM-DD')}
						/>
					</Col>
					<Form.Label column className='col-auto'>
						Type
					</Form.Label>
					<Col className='col-auto'>
						<Form.Select
							name='reportType'
							onChange={(e) => handleFieldChange(e)}
							className="w-auto report-dropdown"
						>
							<option value="PaymentWise" selected>Payment Wise</option>
							<option value="ClientWise">Client Wise</option>
						</Form.Select>
					</Col>

					<Col className='col-auto next-date-button me3'>
						<Button onClick={() => GenerateCashCollectionReport()}>Generate Report</Button>
					</Col>

				</Row>

			</Form > */}
<Form className="details-form cash-Collection-Report">
  <Row className='justify-content-start ms-2'>
    <Form.Label column className='col-12 col-md-auto mb-2'>
      From Date
    </Form.Label>
    <Col className='col-12 col-md-auto mb-2'>
      <Form.Control
        type='date'
        id="dtFromDate"
        name="fromDate"
        onChange={handleFieldChange}
        value={cashCollectionReportData.fromDate
          ? Moment(cashCollectionReportData.fromDate).format('YYYY-MM-DD')
          : Moment().format('YYYY-MM-DD')}
      />
    </Col>

    <Form.Label column className='col-12 col-md-auto mb-2'>
      To Date
    </Form.Label>
    <Col className='col-12 col-md-auto mb-2'>
      <Form.Control
        type='date'
        id="dtToDate"
        name="toDate"
        onChange={handleFieldChange}
        value={cashCollectionReportData.toDate
          ? Moment(cashCollectionReportData.toDate).format('YYYY-MM-DD')
          : Moment().format('YYYY-MM-DD')}
      />
    </Col>

    <Form.Label column className='col-12 col-md-auto mb-2'>
      Type
    </Form.Label>
    <Col className='col-12 col-md-auto mb-2'>
      <Form.Select
        name='reportType'
        onChange={(e) => handleFieldChange(e)}
        className="w-100 w-md-auto report-dropdown"
        defaultValue="PaymentWise"
      >
        <option value="PaymentWise">Payment Wise</option>
        <option value="ClientWise">Client Wise</option>
      </Form.Select>
    </Col>

    <Col className='col-12 col-md-auto mt-2 mt-md-0 case-collection-gr-btn'>
      <Button onClick={() => GenerateCashCollectionReport()}>Generate Report</Button>
    </Col>
  </Row>
</Form>

		</>
	)
}